import type { AppShellResources } from '../en/app-shell';

// Typed against the English shape: German must carry exactly the same keys.
export const appShell: AppShellResources = {
  nav: {
    fleetManagement: 'Fuhrpark',
    vehicles: 'Fahrzeuge',
    contracts: 'Verträge',
    drivers: 'Fahrer',
    developer: 'Entwickler',
    demo: 'Demo',
    organization: 'Organisation',
    users: 'Benutzer',
    locations: 'Standorte',
  },
  userMenu: {
    account: 'Konto',
    billing: 'Abrechnung',
    notifications: 'Benachrichtigungen',
    legal: 'Rechtliches',
    logout: 'Abmelden',
  },
  legal: {
    privacy: 'Datenschutz',
    imprint: 'Impressum',
  },
  signingOut: 'Abmelden …',
  language: {
    german: 'Deutsch',
    english: 'English',
  },
};
